<!--  -->
<template>
  <div class='form' @touchmove.prevent>
    <mt-button type="primary" size="small" @click="applyForm">{{btnText}}</mt-button>
    <div class="formPopup">
      <mt-popup
        v-model="formVisible">
        <div class="formVisible">
          <h4>{{btnText}}</h4>
          <form action="">
            <ul class="inputList">
              <li v-for="(item,index) in inputList" :key="index">
                <div v-if="item.show">
                  <label for=""><i v-if="item.required">*</i>{{item.name}}</label>
                  <div  v-if="item.name!='城市'">
                    <input v-if="item.type=='text'" v-model="item.value" :placeholder="item.placeholder" type="text">
                    <textarea v-else v-model="item.value" :placeholder="item.placeholder"  :class="item.type" type="text"></textarea>
                  </div>
                  <div v-else>
                    <span @click="inputFocus(item)">{{item.value}}</span>
                    <input v-model="item.value" :placeholder="item.placeholder" type="text" hidden> 
                  </div>
                </div>
                <p class="error" v-if="item.errMsgShow">{{item.errMsg}}</p>
              </li>
            </ul>
          </form>
        </div>
        <div class="btn"><mt-button type="primary" size="small" @click.native="submit"> 提交申请</mt-button></div>
      </mt-popup>
    </div>
    <div class="cityPopup">
      <mt-popup v-model="cityVisible"   position="bottom" :closeOnClickModal="false">
        <div class="picker-toolbar">
          <span class="mint-datetime-cancel"  @click='cancel'>取消</span>
          <span class="mint-datetime-confirm" @click='confirm'>确定</span>
        </div>
        <div class="picker" v-if="cityVisible">
        <mt-picker :slots="province" @change="onProvinceChange"  value-key="value"></mt-picker>
        <div class="line">--</div>
        <mt-picker :slots="citys" @change="onCityChange"  value-key="value"></mt-picker>
        </div>
      </mt-popup>
    </div>
  </div>
</template>
<script>
import {cityData} from '../utils/city'
import Api from '@api/apply'
import { Toast , Icon} from 'mint-ui'
 export default {
  name:'applayFrom',
  components: {},
  props:{
    btnText:{
      type:String,
      default:'开通申请'
    },
    channel:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      formVisible:false,
      inputList:[
        {
          placeholder:'请输入公司名',
          name:'公司名称',
          required:false,
          value:'',
          show:true,
          Attribute:'compName',
          errMsgShow:false,
          errMsg:'请输入公司名',
          type:'text'
        },
        {
          placeholder:"请输入姓名",
          name:'姓名',
          required:true,
          value:'',
          errMsg:'请输入姓名',
          show:true,
          Attribute:'contactName',
          errMsgShow:false,
          type:'text'
        },
        {
          placeholder:'请输入手机号码',
          name:'手机号',
          required:true,
          value:'',
          errMsg:'请输入手机号码',
          show:true,
          Attribute:'contactPhone',
          errMsgShow:false,
          type:'text'
        },
        {
          placeholder:'请输入邮箱',
          name:'邮箱',
          required:false,
          value:'',
          errMsg:'请输入邮箱',
          show:true,
          Attribute:'contactMail',
          errMsgShow:false,
          type:'text'
        },
        {
          placeholder:'请选择城市',
          name:'城市',
          required:true,
          value:'北京/东城区',
          errMsg:'请选择城市',
          show:true,
          Attribute:'city',
          errMsgShow:false,
          type:'text'
        },
        {
          placeholder:'请填写需求说明',
          name:'需求说明',
          required:false,
          value:'',
          show:false,
          Attribute:'applyDesc',
          errMsgShow:false,
          type:'textarea'
        }
      ],
      cityVisible:false,
      citySlot:cityData,
      cityChildren:[],
      province: [
        {
          flex: 1,
          defaultIndex:0,
          values: [],
          className: 'slot1',
          textAlign: 'right'
        }
      ],
      citys:[
        {
          flex: 1,
          values: [],
          defaultIndex:0,
          className: 'slot3',
          textAlign: 'left'
        }
      ],
      cityDataReady:false,
      areaProvince:'北京',
      areaCity:'东城区',
    };
  },
  computed: {},
  watch: {
    channel:{
      handler(){
        this.checkChannel()
      },
      deep:true
    }
  },
  created() {
    this.checkChannel()
    this.cityInit()
  },
  mounted() {

  },
  //方法集合
  methods: {
    checkChannel(){
      if(this.channel){
        this.inputList[3].show = false
        this.inputList[5].show = true
        this.inputList[0].required = true
      }else{
        this.inputList[3].show = true
        this.inputList[5].show = false
        this.inputList[0].required = false
      }
    },
     cityInit(){
      this.province[0].values = this.citySlot
      this.citys[0].values =  this.citySlot[0].children
      this.cityDataReady = true
    },
    applyForm(){
      this.formVisible = this.formVisible?false:true
      this.clearInputValue()
    },
    submit(){
      let valid =  this.validateAll()
      let params = {}
      let cityArry = []
      if(valid){
        this.inputList.map(item=>{
          params[item.Attribute] = item.value
        })
        cityArry = params.city.split('/')
        // this.formVisible = false;
        params.areaProvince = cityArry[0]
        params.areaCity = cityArry[1]
        delete params.city
        this.submitApi(params)
      }else{
        // this.formVisible = false;
      }
    },
    submitApi(params){
      if(this.channel){
        Api.fetchSaveChannel(params).then(res=>{
          this.formVisible = false;
          Toast({
              message: '提交成功',
              iconClass: 'icon icon-success',
              duration: 2000
            });
        })
     
      }else{
        Api.fetchSaveCompany(params).then(res=>{
          this.formVisible = false;
          Toast({
            message: '提交成功',
            iconClass: 'icon icon-success',
            duration: 2000
          });
        })
      }
    },
    isWscnEmail (str) {
      if(str!=''){
        const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
        return reg.test(str.trim())
      }
    },
    checkPhone(value){
      const reg =  /^(0?1[123456789]\d{9})$/
      if(value == ''){
        return {
          errMsgShow:true,
          errMsg:'请输入手机号'
        }
      }else if(!reg.test(value)){
        return {
          errMsgShow:true,
          errMsg:'请输入正确的手机号码'
        }
      }else{
        return {
          errMsgShow:false,
        }
      }
    },
    //校验
    validateAll(){
      console.log(this)
      let valid = true
      let count = 0
      this.inputList.forEach((field,index) => {
        if(field.required&&field.value==''){
          field.errMsgShow = true
          valid = false
        }else if(field.Attribute=="contactPhone"){
          if(this.checkPhone(field.value).errMsgShow){
            field.errMsgShow = true
            field.errMsg = '请输入正确的手机号码'
            valid = false
          }else{
            field.errMsgShow = false
          }
        }else if(field.Attribute=="contactMail"&&field.value!=''){
          console.log(field.value)
          if(!this.isWscnEmail(field.value)){
           field.errMsgShow = true
           field.errMsg = '请输入正确的邮箱'   
           valid = false
          }else{
            field.errMsgShow = false
          }
        }else{
          field.errMsgShow = false
        }
      })
      return valid;
    },
    clearInputValue(){
      this.inputList.map((item)=>{
        item.value = ''
        item.errMsgShow = false
      })
      this.inputList[4].value = '北京/东城区'
    },
    inputFocus(item){
      if(item.name == '城市'){
        this.cityVisible = true;
      }
    },
    onProvinceChange(picker,values){
      if(this.cityDataReady){
        this.areaProvince = values[0].value
        this.$set(this.citys[0],'values', values[0].children)
      }
    },
     onCityChange(picker,values){
      if(this.cityDataReady){
        this.areaCity = values[0].value
      }
    },
    cancel(){
      this.cityVisible = false;
      this.inputList[4].value = '北京/东城区'
    },
    confirm(){
      this.cityVisible = false;
      this.inputList[4].value =  this.areaProvince + '/' + this.areaCity
    }
  },
}
</script>
<style lang='scss'>
  //@import url(); 引入公共css类
  .form{
    position: relative;
    z-index:1000;
    .formPopup .mint-popup{
      // width:80%;
      border-radius:25px;
      z-index:2;
    }
    .formVisible{
      padding:50px 30px 30px;
      h4{
        color:#000;
        font-size:36px;
        margin-bottom:30px;
        text-align: center;
      }
      a:hover{
        text-decoration: none;
      } 
    }
    .btn{
      text-align: center;
      margin-bottom:60px;
    }
  }

  .inputList{
    li{
      .error{
        text-align: left;
        color:red;
        font-size:22px;
        padding-left:160px;
      }
      margin-bottom:20px;
    }
    li>div{
      @include flex;
      
      label{
        width:150px;
        text-align:right; 
        line-height:60px;
        padding-right:10px; 
      }
      i{
        color:red;
      }
      input,span,textarea{
        width:330px;
        height:60px;
        line-height:60px;
        border:2px solid #ccc;
        padding-left:10px;
        box-sizing: border-box;
        font-size:28px;
        border-radius:6px;
        outline: none;
        -webkit-appearance: none;
      }
      span{
        display: block;
      }
      .textarea{
        height:100px;
        line-height: 45px;

      }
    }
  }
  .cityPopup{
    .mint-popup{
      width:100%;
    }
     .picker-toolbar{
      padding:20px 30px;
      .mint-datetime-confirm{
        color:#26a2ff;
      }
      span{
        padding:20px;
      }
    }
  }
  .picker{
      @include flex($just:"space-around",$align:'center');
    .line{
      width:50px;
      margin-top:150px;
      text-align: center;
    }
  } 
</style>